"use strict";
/**
 * Factories for blank editor rows. Each returned object is tagged with a
 * fresh `__clientId` so newly inserted rows can be tracked through
 * reorderings and id renames without identity churn.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEmptyFieldMapping = exports.createEmptyField = exports.createEmptyWorkflow = exports.createEmptySystem = void 0;
var ai_hub_settings_client_ids_1 = require("./ai-hub-settings-client-ids");
/**
 * Create an empty system record for the editor.
 */
exports.createEmptySystem = function () { return ({
    id: '',
    name: '',
    type: '',
    baseUrl: '',
    url: '',
    sync: 'twoWay',
    config: {},
    __clientId: ai_hub_settings_client_ids_1.generateClientId('sys'),
}); };
/**
 * Create an empty workflow record for the editor. Mirrors
 * {@link createEmptySystem} so the Workflows section can reuse the same
 * "row goes into edit mode immediately" UX as the Systems section.
 */
exports.createEmptyWorkflow = function () { return ({
    id: '',
    name: '',
    sources: [],
    targets: [],
    __clientId: ai_hub_settings_client_ids_1.generateClientId('wfl'),
}); };
/**
 * Create an empty field record for the editor.
 */
exports.createEmptyField = function () { return ({
    name: '',
    ignore: false,
    mapping: [exports.createEmptyFieldMapping()],
    __clientId: ai_hub_settings_client_ids_1.generateClientId('fld'),
}); };
/**
 * Create an empty mapping record for the editor.
 */
exports.createEmptyFieldMapping = function () { return ({
    system: '',
    field: '',
    defaultValue: '',
    map: {},
    valueSet: {
        append: false,
        format: '',
    },
    config: {
        userNameSubField: '',
        emailAddressSubField: '',
    },
    __clientId: ai_hub_settings_client_ids_1.generateClientId('map'),
}); };
